import { render, staticRenderFns } from "./ModalRegisterParents.vue?vue&type=template&id=69fef077&scoped=true"
import script from "./ModalRegisterParents.vue?vue&type=script&lang=js"
export * from "./ModalRegisterParents.vue?vue&type=script&lang=js"
import style0 from "./ModalRegisterParents.vue?vue&type=style&index=0&id=69fef077&prod&lang=scss&scoped=true"
import style1 from "./ModalRegisterParents.vue?vue&type=style&index=1&id=69fef077&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fef077",
  null
  
)

export default component.exports